import React from "react";
import "./Hero.css";

const Hero = () => {
  const scrollToGallery = () => {
    const gallerySection = document.getElementById("gallery");
    if (gallerySection) {
      gallerySection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const playVideo = () => {
    const videoUrl = "/video.mp4";
    const videoWindow = window.open(videoUrl, "_blank");
    videoWindow.focus();
  };

  return (
    <div className="hero">
      <div className="hero-content">
        <h1>Galería Sofía y Nacho</h1>
        <div className="hero-buttons">
          <button onClick={scrollToGallery}>Ver Fotos</button>
          <button onClick={playVideo}>Ver Video</button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
